import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { colorsModeUI } from '../modeUI';
import './index.css';

export const SENSOR_BOX_COLOR_1 = 1;
export const SENSOR_BOX_COLOR_2 = 2;
export const SENSOR_BOX_COLOR_3 = 3;
export const SENSOR_BOX_COLOR_4 = 4;
export const SENSOR_BOX_COLOR_ERROR = -1;
export const SENSOR_BOX_COLOR_OK = -2;
export const SENSOR_BOX_COLOR_INFORMATION = -3;
/**
 * BoxSensor
 * Display a colored box with sensor data (value, unit and title)
 * parameters (props)
 * @param string value
 * @param string titleValue
 * @param string unitValue
 * @param number sensorBoxColor => decides the color [SENSOR_BOX_COLOR_1,
 * SENSOR_BOX_COLOR_2,
 * SENSOR_BOX_COLOR_3,
 * SENSOR_BOX_COLOR_4,
 * SENSOR_BOX_COLOR_ERROR,
 * SENSOR_BOX_COLOR_OK,
 * SENSOR_BOX_COLOR_INFORMATION]
 * @param string mode
 * @param string titleAlarm: the name of the alarm to be displayed together
 *  with the icon warning sign (if present)
 */
export default class BoxSensor extends React.PureComponent {
  render() {
    const {
      value,
      titleValue,
      unitValue,
      mode,
      sensorBoxColor,
      titleAlarm,
      style,
      ...otherProps
    } = this.props;
    const styleBox = { ...style };
    /* mode UI: dark mode/light mode */
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleBox.color = modeColors.BOX_SENSOR_COLOR;
      switch (sensorBoxColor) {
        case SENSOR_BOX_COLOR_1:
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_1;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_1;
          break;
        case SENSOR_BOX_COLOR_2:
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_2;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_2;
          break;
        case SENSOR_BOX_COLOR_3:
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_3;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_3;
          break;
        case SENSOR_BOX_COLOR_4:
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_4;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_4;
          break;
        case SENSOR_BOX_COLOR_ERROR: {
          styleBox.backgroundColor =
            modeColors.BOX_SENSOR_BACKGROUND_COLOR_ERROR;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_ERROR;
          break;
        }
        case SENSOR_BOX_COLOR_OK: {
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_OK;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_OK;
          break;
        }
        case SENSOR_BOX_COLOR_INFORMATION: {
          styleBox.backgroundColor =
            modeColors.BOX_SENSOR_BACKGROUND_COLOR_INFORMATION;
          styleBox.borderColor =
            modeColors.BOX_SENSOR_BACKGROUND_COLOR_INFORMATION;
          break;
        }
        default:
          styleBox.backgroundColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_1;
          styleBox.borderColor = modeColors.BOX_SENSOR_BACKGROUND_COLOR_1;
      }
    }
    return (
      <Card className="box-sensor" style={styleBox} {...otherProps}>
        <Card.Content textAlign="center">
          <div className="title-value">{titleValue}</div>
          <div className="value-unit">
            <div className="value">{value}</div>
            <div className="unit">{unitValue}</div>
          </div>
          {titleAlarm && (
            <div className="icon-alarm-wrapper">
              <div>
                <Icon name="warning sign" size="small" key="alarms" />
              </div>
              <div className="titleAlarm">{titleAlarm}</div>
            </div>
          )}
        </Card.Content>
      </Card>
    );
  }
}

BoxSensor.propTypes = {
  value: PropTypes.string.isRequired,
  titleValue: PropTypes.string,
  unitValue: PropTypes.string,
  mode: PropTypes.string,
  sensorBoxColor: PropTypes.number,
  titleAlarm: PropTypes.string,
};

BoxSensor.defaultProps = {
  titleValue: null,
  unitValue: null,
  mode: null,
  sensorBoxColor: SENSOR_BOX_COLOR_1,
  titleAlarm: null,
};
